import { PropsWithChildren } from 'react';
import { ThemeProvider } from './ThemeProvider';
import { IThemeContext } from '@/interfaces';

export function UIProvider({
  children,
  themeResolver,
}: { themeResolver: () => Promise<IThemeContext> } & PropsWithChildren) {
  return <ThemeProvider themeResolver={themeResolver}>{children}</ThemeProvider>;
}
